import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'

import { DefaultNewActivityForm, schema } from './new-activity-form-schema'

export function NewActivityFormProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const methods = useForm<DefaultNewActivityForm>({
    resolver: zodResolver(schema),

    defaultValues: {
      activity_type: '' as DefaultNewActivityForm['activity_type'],
    },
  })
  return <FormProvider {...methods}>{children}</FormProvider>
}
export const useNewActivityForm = () => {
  return useFormContext<DefaultNewActivityForm>()
}
